<app-letsikring-til-selvstaendige
  [form]="form"
  [editMode]="editMode()"
  [revision]="revision()"
  (selectLivrente)="onSelectLivrente()"
  (selectTilknyttet)="onSelectTilknyttet($event)" />

<h3 class="mb-4">
  {{ getProduktNavn() }}
</h3>

<app-letsikring-system
  [revision]="revision()"
  [letsikring]="letsikring()"
  [risiko]="selectedRisiko()" />
<app-letsikring-stamoplysninger
  [form]="form"
  [editMode]="editMode()"
  [revision]="revision()"
  [letsikring]="letsikring()"
  [risiko]="selectedRisiko()"
  [livrente]="selectedLivrente()" />

@let letsikringRisiko = selectedRisiko();
@if (letsikringRisiko) {
  <app-letsikring-risiko
    [form]="form"
    [editMode]="editMode()"
    [revision]="revision()"
    [letsikring]="letsikring()"
    [letsikringRisiko]="letsikringRisiko" />
}

@let letsikringAfIndtaegt = selectedLivrente();
@if (letsikringAfIndtaegt) {
  <app-letsikring-af-indtaegt
    [form]="form"
    [editMode]="editMode()"
    [revision]="revision()"
    [letsikring]="letsikring()"
    [letsikringAfIndtaegt]="letsikringAfIndtaegt" />
}

<app-letsikring-synkronisering
  [form]="form"
  [editMode]="editMode()"
  [revision]="revision()" />
